<template>
  <v-row>
    <v-col>
      <login-card v-if="!loading"/>
    </v-col>
  </v-row>
</template>

<script>
import LoginCard from '@/components/unauth/login/LoginCard';

export default {
  name: 'LoginView',
  components: {
    LoginCard,
  },
  computed: {
    loading: vm => vm.$store.getters.loading,
  },
};
</script>
